import { BN } from "@coral-xyz/anchor";

export function lamportsBNToNumber(amount: BN, decimals: number): number {
  const divisor = new BN(10).pow(new BN(decimals));
  const result = amount.mul(new BN(10).pow(new BN(decimals))).div(divisor);
  return parseFloat(result.toString()) / 10 ** decimals;
}
